<template>
  <task-page class="font-degular max-w-2xl" v-if="isDataLoaded">
    <task-list :log="log" />
  </task-page>
</template>

<script>
import TaskList from '@/components/TaskList'
import TaskPage from '@/components/TaskPage'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'WeeklyTasks',
  components: {
    TaskList,
    TaskPage
  },
  computed: {
    ...mapState('config', ['isDataLoaded']),
    ...mapGetters('storeModule', ['weeklyLog']),
    ...mapGetters('storeModule/logs', ['logById']),
    ...mapGetters('global', ['weeklyTasks']),
    log() {
      return this.weeklyLog ? this.logById(this.weeklyLog) : null
    }
  }
}
</script>
